import React from 'react';

import { Flex, theme } from '@betterment/style-closet-react';
import ContentLoader from 'react-content-loader';

const LeftShimmer: React.FC<React.PropsWithChildren<unknown>> = () => (
  <ContentLoader
    style={{ display: 'block' }}
    gradientRatio={2}
    height={102}
    width={272}
    speed={0.99}
    interval={0.2}
    primaryColor={theme.colors.bmtGrey10}
    secondaryColor={theme.colors.bmtGrey20}
  >
    <rect x="86" y="34" rx="0" ry="0" width="186" height="14" />
    <rect x="86" y="56" rx="0" ry="0" width="88" height="14" />
    <rect x="24" y="34" rx="5" ry="5" width="36" height="36" />
  </ContentLoader>
);

const RightShimmer: React.FC<React.PropsWithChildren<unknown>> = () => (
  <ContentLoader
    style={{ display: 'block' }}
    gradientRatio={2}
    height={102}
    width={112}
    speed={0.99}
    interval={0.2}
    primaryColor={theme.colors.bmtGrey10}
    secondaryColor={theme.colors.bmtGrey20}
  >
    <rect x="0" y="45" rx="0" ry="0" width="88" height="14" />
  </ContentLoader>
);

const EnrichedTransactionLoader: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Flex
    borderBottom="1px solid"
    borderColor="bmtGrey20"
    justifyContent="space-between"
    height="76px"
    alignItems="center"
    aria-label="Loading transaction"
  >
    <Flex display="block" flexBasis="272px" mr="6">
      <LeftShimmer />
    </Flex>
    <Flex display="block" flexBasis="112px">
      <RightShimmer />
    </Flex>
  </Flex>
);

export default EnrichedTransactionLoader;
